<template>
    <v-container>
        <v-card>
            <v-card-title v-if="loggedIn" class="primary"><span class="white--text">Logged In</span></v-card-title>
            <v-card-text>
                You are logged in. Reset only works if you are viewing anonymously.
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        name: 'reset',
        computed: {
            loggedIn: function () {
                return this.$store.state.loggedIn
            }
        },
        mounted() {
            localStorage.removeItem("program")
            this.$store.dispatch("setDefaultBranding")
            this.$router.push("/")
        }
    }
</script>